import { IPersonalDetails } from "core/types/api/mix";
import moment from "moment";

export const getMainClientData = (fullClientData: IPersonalDetails) => (fullClientData ? {
    id: fullClientData?.id,
    age: Math.ceil(moment(moment()
        .format('YYYY-MM-DD'))
        .diff(moment(fullClientData?.details?.personalInformation?.dateOfBirth), 'years', true)),
    firstName: `${fullClientData?.details?.personalInformation?.firstName}`,
    lastName: `${fullClientData?.details?.personalInformation?.lastName}`,
    name: `${fullClientData?.details?.personalInformation?.firstName} ${fullClientData?.details?.personalInformation?.lastName}`,
    countryOfResidence: fullClientData?.details?.personalInformation?.primaryAddressCountry,
    taxData: fullClientData?.details?.taxSituation,
    gender: fullClientData?.details?.personalInformation?.gender,
    nationality: fullClientData?.details?.personalInformation?.identification?.[0]?.countryOfNationality,
    isZurichEmployee: fullClientData?.details?.personalInformation?.zurichMA || false,
    destinataryVita: fullClientData?.details?.personalInformation?.destinedLife || false,
    affiliatedPensionFund: fullClientData?.details?.personalInformation?.affiliatedPensionFund,
    employmentContinuation: fullClientData?.details?.personalInformation?.employmentContinuation,
} : undefined);
